import template from './acceptableAccordionSection.html';
import { AcceptableAccordionSectionController } from './acceptableAccordionSection.controller';

export const acceptableAccordionSectionComponent = {
  name: 'acceptableAccordionSection',
  restrict: 'E',
  transclude: true,
  template,
  controller: AcceptableAccordionSectionController,
  controllerAs: 'vm',
  bindings: {
    header: '@',
    isOpen: '<',
    onOpen: '&',
    hasError: '<',
    status: '<',
    item: '=',
    formValid: '=',
    showSaveButton: '<',
    showAutoApplyStandingOrdersButton: '<',
    onChangeStatus: '&',
    onSaveChanges: '&',
    saveButtonLoading: '<',
    autoApplyButtonLoading: '<',
  },
};
